import { render } from "./FnNoticeBell.vue?vue&type=template&id=1cf50083"
import script from "./FnNoticeBell.vue?vue&type=script&lang=js"
export * from "./FnNoticeBell.vue?vue&type=script&lang=js"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__